module.exports = __webpack_public_path__ + "img/arrow.573bfd92.svg";